export const listMember = [
  {
    id: "dao-duy-tuan",
    name: "Đào Duy Tuấn",
    position: "Chủ nhiệm",
    role: "memberLead",
    img: "./imgMembers/dao-duy-tuan.jpg",
    strengths: [
      "IoT",
      "Computer Network",
      "Mobility Management",
      "Wireless Communication",
      "Vehicular Network",
    ],
    describe: [
      "- Từ 2015- 2019: Nghiên cứu sinh tại Đài Loan (chuyên ngành Khoa học máy tính và Kỹ thuật thông tin) (website: https://web.ncku.edu.tw/).",
      "- Từ 10/2019-nay: Giảng viên, Bộ môn Kỹ thuật máy tính, Khoa Điện Tử Viễn Thông, Trường Đại học Bách khoa - Đại học Đà Nẵng.",
      "- Từ 7/2020 - nay: Chủ tịch CLB SV NCKH Pioneer khoa Điện Tử - Viễn Thông",
      "- Từ 7/2022 - nay: Bí thư Liên Chi đoàn khoa Điện Tử - Viễn Thông",
    ],

    facebook: "https://www.facebook.com/Tuan.Dao.Duy",
    gmail: " ddtuan@dut.udn.vn",
    github: "0976306692",
    linkedin: "http://scv.udn.vn/ddtuan/",
  },

  {
    id: "ton-that-hai",
    name: "Tôn Thất Hải",
    classes: "20KTMT2",
    position: "Phó Chủ nhiệm",
    role: "memberLead",
    strengths: ["WEB", "APP", "ALGORITHM", "EMBEDDED", "IOT"],
    img: "./imgMembers/ton that hai.jpg",
    describe: "Nỗ lực của hôm nay là thành công cho ngày mai ",
    facebook: "https://www.facebook.com/Hai2606ton/",
    gmail: "haitt.bkdn@gmail.com",
    github: "https://github.com/haiton266",
    linkedin: "https://www.facebook.com/Hai2606ton/",
  },

  // ----------------------------------------------------------------
  {
    id: "dao-trong-nhan",
    name: "Đào Trọng Nhân",
    classes: "19DTCLC3",
    position: "Trưởng ban Hệ thống nhúng/IOTs",
    role: "teamLeader",
    strengths: ["WEB", "APP", "ALGORITHM", "EMBEDDED", "IOT"],
    img: "./imgMembers/dao trong nhan.jpg",
    describe: "",
    facebook: "https://www.facebook.com/Rekii.Rockie/",
    gmail: "dtnhan.ete.dut@gmail.com",
    github: "https://github.com/Rekiichan",
    linkedin: "",
  },

  {
    id: "hoang-ngoc-loc",
    name: "Hoàng Ngọc Lộc ",
    classes: "20KTMT2",
    position: "Trưởng ban Web/App + Thuật toán",
    role: "teamLeader",
    strengths: ["WEB", "APP", "ALGORITHM", "AI"],
    img: "./imgMembers/hoang ngoc loc.jpg",
    describe:
      "Xin chào, mình là Lộc. Hiện minh đang nghiên cứu mảng Web, tương lai mong muốn trở thành 1 Fullstack Developer. Ngoài ra mình cũng đang nghiên cứu thêm về Machine Learning.",
    reward: {
      rank: "",
      contestName: "",
      img: "",
    },
    facebook: "https://www.facebook.com/reddevils.1908",
    gmail: "valentinohoang1908@gmail.com",
    github: "https://github.com/jCool10",
    linkedin: "https://www.linkedin.com/in/hoang-ngoc-loc-171a95229/",
  },

  {
    id: "le-trong-phuoc",
    name: "Lê Trọng Phước",
    classes: "19DTCLC3",
    position: "Trưởng ban Điện Tử",
    role: "teamLeader",
    strengths: ["ELECTRONIC"],
    img: "./imgMembers/le trong phuoc.png",
    describe: `"Xin chào! Mình là Lê Trọng Phước, sinh viên năm 4 của Khoa Điện Tử-Viễn Thông, hiện tại mình là Trưởng ban Điện tử CLB Pioneer. 
    Có 1 câu nói của Isaac Niuton mà mình luôn tâm đắc ""Nếu tôi nhìn xa hơn người khác thì đó là nhờ tôi đứng trên vai nhưng người khổng lồ"" vì đây mình luôn cố gắng học tập những điều hay từ mọi người xung quanh và từ những người ""khổng lồ"", học tập để đối nhân xử thế, không trở nên vô dụng và tạo được dấu ấn đẹp.
    Mình cũng đạt được 1 số thành tựu về phương diện cá nhân lẫn tập thể: 3 năm là sinh viên giỏi, xuất sắc; giải nhất Bóng đá ETE, giải nhất LMHT ETE, giải nhì Auturace,... tuy có lẽ không đáng nói với người khác nhưng với mình nó là nền tảng để mình có động lực tiến về phía trước để một ngày không xa có thể thực hiện những ước mơ của mình."`,

    facebook: "https://www.facebook.com/trongphuoc.le.50/",
    gmail: "trongphuocle001@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "nguyen-tue-tam",
    name: "Nguyễn Tuệ Tâm",
    classes: "19DTCLC1",
    position: "Trưởng ban AI",
    role: "teamLeader",
    img: "./imgMembers/nguyen tue tam.jpeg",
    describe: "Learn with curiosity ",

    facebook: "https://www.facebook.com/i.mtue.tam",
    gmail: "tuetam011204@gmail.com",
    github: "https://github.com/ngtuetam",
    linkedin: "",
  },

  {
    id: "truong-cong-phuoc",
    name: "Trương Công Phước",
    classes: "19DTCLC4",
    position: "Trưởng ban Truyền Thông",
    strengths: ["MEDIA", "ELECTRONIC"],
    role: "teamLeader",
    img: "./imgMembers/truong cong phuoc.jpg",
    describe:
      "Tôi nghĩ nếu bạn làm điều gì đó và thu được kết quả tốt đẹp, bạn nên đi tiếp để làm những điều tuyệt vời khác, đừng dừng chân lại quá lâu. Hãy tìm xem nên làm gì tiếp.",

    facebook: "https://www.facebook.com/phuoctruongcong.truong/",
    gmail: "phuoctruongcong2001@gmail.com",
    github: "",
    linkedin: "",
  },

  // ----------------------------------------------

  {
    id: "nguyen-duy-tuan-nguyen",
    name: "Nguyễn Duy Tuấn Nguyên",
    classes: "20DT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/nguyen duy tuan nguyen.jpg",
    strengths: ["WEB", "APP", "ALGORITHM"],
    describe: "tuổi 20 năm cao 1m64 nặng 63kg",

    facebook: "https://www.facebook.com/ndtn.leesin/",
    gmail: "ndtnguyen2108@gmail.com",
    github: "https://github.com/TuanNguyen2108",
    linkedin: "",
  },

  {
    id: "nguyen-ngoc-trung",
    name: "Nguyễn Ngọc Trung",
    classes: "21KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/nguyen ngoc trung.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "AI", "IOT", "EMBEDDED"],
    describe: `"Tên : Nguyễn Ngọc Trung - SV Năm 2 
    Lớp : 21KTMT2 
    Ngành : Kĩ Thuật Máy Tính 
    Khoa : Điện Tử Viễn Thông
    Lĩnh Vực Yêu Thích : AI / IOT"`,

    facebook: "https://www.facebook.com/nguoithichcuoi102",
    gmail: "trungnguyenraz@gmail.com",
    github: "https://github.com/Trung-Logarit",
    linkedin: "",
  },

  {
    id: "tran-thanh-khoa",
    name: "Trần Thanh Khoa",
    classes: "21DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/tran thanh khoa.jpg",
    strengths: ["WEB", "APP", "ALGORITHM"],
    describe: "Em là Trần Thanh Khoa lớp 21DT1,",

    facebook: "https://www.facebook.com/DraGonFestRacingBoiz/",
    gmail: "haohancoder@gmail.com",
    github: "https://github.com/DeThanh",
    linkedin: "",
  },

  {
    id: "le-pham-cong",
    name: "Lê Phạm Công ",
    classes: "20KTMT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/le  pham cong.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "EMBEDDED", "IOT", "ELECTRONIC"],
    describe:
      "Xin chào, mình là Công, mình đến từ Quảng Nam, hiện tại mình đang học ngành Kỹ thuật máy tính và là thành viên Câu lạc bộ sinh viên nghiên cứu khoa học Pioneer.",

    facebook: "https://www.facebook.com/lephamcong.dev.vn",
    gmail: "lpc051002@gmail.com",
    github: "https://github.com/lephamcong",
    linkedin: "https://www.linkedin.com/in/le-pham-cong/",
  },

  {
    id: "dang-duc-chinh",
    name: "Đặng Đức Chính ",
    classes: "21KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/dang duc chinh.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "AI"],
    describe:
      "Mình đến từ một vùng nông thôn ở Quảng Nam, mang theo sự kỳ vọng của gia đình trên con đường đến với đại học. Mình thực sự yêu thích và có một niềm đam mê kỳ lạ với công nghệ.",

    facebook: "https://www.facebook.com/ducchinh270503/",
    gmail: "dangducchinh27052003@gmail.com",
    github: "https://github.com/ducchinh270503",
    linkedin: "https://www.linkedin.com/in/chinh-dang-17792424b/",
  },

  {
    id: "pham-duc-thang",
    name: "Phạm Đức Thắng",
    classes: "18DT3",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/pham duc thang.jpg",
    strengths: ["EMBEDDED", "IOT"],
    describe:
      "Mình là sinh viên khóa 18 khoa ĐTVT, chuyên ngành KTMT. Tham gia CLB từ năm 2018 đến nay. Mình đang định hướng theo lĩnh vực nhúng và IoT.",

    facebook: "https://www.facebook.com/DT18DT",
    gmail: "ducthang18dt@gmail.com",
    github: "https://github.com/DucThang18DT",
    linkedin: "https://www.linkedin.com/in/thangpham18dt/",
  },

  {
    id: "mai-tien-dat",
    name: "Mai Tiến Đạt",
    classes: "19DTCLC4",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/mai tien dat.jpg",
    strengths: ["ELECTRONIC", "EMBEDDED", "IOT"],
    describe: "Khoá 19, chuyên ngành điện tử",

    facebook: "https://www.facebook.com/tiendat8621",
    gmail: "tiendat8621@gmail.com",
    github: "https://github.com/TienDat8621",
    linkedin: "",
  },

  {
    id: "ngo-xuan-sy",
    name: "Ngô Xuân Sỹ",
    classes: "20KTMT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/ngo xuan sy.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "EMBEDDED", "IOT"],
    describe: "hòa đồng vui vẻ",

    facebook: "https://www.facebook.com/traises.ems",
    gmail: "ngoxuansy30082002@gmail.com",
    github: "https://github.com/ngoxuansy30082002",
    linkedin: "",
  },

  {
    id: "dao-van-minh",
    name: "Đào Văn Minh",
    classes: "21KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/dao van minh.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "AI", "MEDIA"],
    describe:
      "Mình khá thích giao lưu ( về mọi mặt từ bàn nhậu tới thể thao và cả code ) :> Kinh nghiệm còn non mong mọi người giúp đỡ",

    facebook: "https://www.facebook.com/dvminnh",
    gmail: "dvminh1347@gmail.com",
    github: "https://github.com/Daominnh",
    linkedin: "",
  },

  {
    id: "le-dinh-phuoc",
    name: "Lê Đình Phước",
    classes: "21DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/le dinh phuoc.jpg",
    strengths: ["ELECTRONIC"],
    describe:
      "Mình khá thích giao lưu ( về mọi mặt từ bàn nhậu tới thể thao và cả code ) :> Kinh nghiệm còn non mong mọi người giúp đỡ",

    facebook: "facebook.com/phuocdinhle05",
    gmail: "dinhphuocbackspace@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "ta-duc-manh",
    name: "Tạ Đức Mạnh",
    classes: "19DTCLC3",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/ta duc manh.jpg",
    strengths: ["WEB", "APP", "ALGORITHM"],
    describe: "Hello mọi người, mình là Mạnh!",

    facebook: "https://www.facebook.com/ducmanh.se/",
    gmail: "ducmanhdut248@gmail.com",
    github: "https://github.com/immanh",
    linkedin:
      "https://www.linkedin.com/in/%C4%91%E1%BB%A9c-m%E1%BA%A1nh-916041231/",
  },

  {
    id: "tran-thanh-dat",
    name: "Trần Thành Đạt",
    classes: "21DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/tran thanh dat.jpg",
    strengths: ["MEDIA"],
    describe: "Thích chụp ảnh, xem anime, tìm hiểu lịch sử",

    facebook: "https://www.facebook.com/thanhdatxd25",
    gmail: "tranthanhdatqv@gmail.com",
    github: "https://github.com/ThanhDatop25",
    linkedin: "",
  },

  {
    id: "vo-pham-gia-huy",
    name: "Võ Phạm Gia Huy",
    classes: "20KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/vo pham gia huy.jpeg",
    strengths: ["WEB", "APP", "ALGORITHM"],
    describe: "Không có gì cả",

    facebook: "https://www.facebook.com/profile.php?id=100025664993472",
    gmail: "Ghuy100202@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "nguyen-tan-dat",
    name: "Nguyễn Tấn Đạt",
    classes: "20DTCLC1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/nguyen tan dat.png",
    strengths: ["ELECTRONIC"],
    describe: " ",

    facebook: "https://www.facebook.com/kaledinwindsky/",
    gmail: "nguyentandata3ddt2020@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "dinh-van-quang",
    name: "Đinh Văn Quang",
    classes: "20DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/Dinh Van Quang.jpg",
    strengths: ["AI", "EMBEDDED", "IOT"],
    describe:
      "Mình là Đinh Văn Quang, hiện đang là sinh viên năm 3 ngành Điện Tử Viễn Thông. Lĩnh vực đang nghiên cứu lập trình nhúng và AI.",

    facebook: "https://www.facebook.com/profile.php?id=100013790596542",
    gmail: "nvanquang17th@gmail.com",
    github: "https://github.com/quang17th",
    linkedin: "linkedin.com/in/vanquang17th/",
  },

  {
    id: "nguyen-nhat-minh",
    name: "Nguyễn Nhật Minh",
    classes: "20DTCLC1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/nguyen nhat minh.jpg",
    strengths: ["EMBEDDED", "IOT"],
    describe: "Khá là ngại ngùng :)",

    facebook: "https://www.facebook.com/nhatminhd27th/",
    gmail: "nhatminhd27th@gmail.com",
    github: "",
    linkedin:
      "https://www.linkedin.com/in/nguy%E1%BB%85n-nh%E1%BA%ADt-minh-0a8913202/",
  },

  {
    id: "tran-thi-thanh-nga",
    name: "Trần Thị Thanh Nga",
    classes: "21DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/tran thi thanh nga.jpg",
    strengths: ["ELECTRONIC"],
    describe:
      "Xin chào mọi người, mình là Thanh Nga. Chắc hẳn là mọi người thấy khá ít nữ theo đuổi mảng điện tử nhỉ? Mình là 1 trong số đó, hiện tại mình đang trau dồi kiến thức và cố gắng hoàn thiện bản thân hơn mỗi ngày để có thể làm việc ở mảng Điện tử này. Hy vọng có thể làm quen được những người bạn mới và các anh chị trong ngành. <3",

    facebook: "https://www.facebook.com/profile.php?id=100013129514860",
    gmail: "thanhngadtvt.dut.dn@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "truong-huy-hoa",
    name: "Trương Huy Hòa ",
    classes: "20DTCLC1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/truong huy hoa.jpg",
    strengths: ["ELECTRINIC", "EMBEDDED", "IOT"],
    describe: `Lớp 20DTCLC1
      Quê quán: QUẢNG TRỊ
      Thời gian rảnh thường chạy bộ, tập gym, thích đi cf học nhóm cùng bạn bè, đọc sách,...
      Châm ngôn sống: think big, do small!`,

    facebook: "https://www.facebook.com/huyhoa308",
    gmail: "huyhoa308@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "thai-van-phuc",
    name: "Thái Văn Phúc",
    classes: "20KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/thai van phuc.jpg",
    strengths: ["WEB", "APP", "ALGORITHM", "AI"],
    describe: `nothing to ..., nothing to ...`,

    facebook: "https://www.facebook.com/ice.pie.2",
    gmail: "phucthaiv02@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "nguyen-van-minh",
    name: "Nguyễn Văn Minh",
    classes: "19DTCLC2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/nguyen van minh.jpg",
    strengths: ["AI", "ELECTRONIC"],
    describe: `à ừm hello, lên đây thăm quan chút thôi`,

    facebook: "https://www.facebook.com/profile.php?id=100018715681829",
    gmail: "nguyenminh121201@gmail.com",
    github: "",
    linkedin: "",
  },

  {
    id: "tran-quang-huyen",
    name: "Trần Quang Huyên",
    classes: "20KTMT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/tran quang huyen.jpg",
    strengths: [
      "WEB",
      "APP",
      "ALGORITHM",
      "AI",
      "ELECTRONIC",
      "EMBEDDED",
      "IOT",
    ],
    describe: `Người giàu ( tình cảm )`,

    facebook: "https://www.facebook.com/tranquang.huyen.5",
    gmail: "huyenquangtran2002@gmail.com",
    github: "https://github.com/Tqhuyen",
    linkedin:
      "https://www.linkedin.com/in/tr%E1%BA%A7n-quang-huy%C3%AAn-4393a8195/",
  },

  {
    id: "phan-tran-chi-hieu",
    name: "Phan Trần Chí Hiếu",
    classes: "20DT1",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/phan tran chi hieu.jpg",
    strengths: ["AI"],
    describe: `Mình tên là Phan Trần Chí Hiếu, sinh viên lớp 20DT1 ngành Điện tử Viễn thông. Mình chuyên về phát triển trí tuệ nhân tạo, mình có niềm đam mê lập trình từ thời học sinh. Sở thích của mình là đọc sách và nghe nhạc mỗi khi rảnh rỗi. Mình mong muốn sau khi tốt nghiệp đại học có thể được làm việc ở công ty đa quốc gia.`,

    facebook: "https://www.facebook.com/profile.php?id=100035557726445",
    gmail: "sonihieu@gmail.com",
    github: "https://github.com/sonihieu",
    linkedin: "",
  },

  {
    id: "phung-thi-anh",
    name: "Phùng Thị Ánh",
    classes: "21TCLC-DT2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/phung thi anh.jpg",
    strengths: ["WEB", "APP", "ALGORITHM"],
    describe: `Hòa đồng, dễ gần, vui tính.`,

    facebook: "https://www.facebook.com/cosspess.dangssyeus/",
    gmail: "anhhna17710110@gmail.com",
    github: "https://github.com/anh29",
    linkedin: "",
  },

  {
    id: "vo-anh-huy",
    name: "Võ Anh Huy",
    classes: "19DTCLC2",
    position: "Thành viên",
    role: "member",
    img: "./imgMembers/vo anh huy.jpg",
    strengths: ["ELECTRONIC"],
    describe: `có niềm đam mê với điện tử, thích chơi đàn guitar, thích nghe nhạc`,

    facebook: "facebook.com/huy.voanh.169",
    gmail: "huyanhvo123@gmail.com",
    github: "",
    linkedin: "",
  },
];
